import InactivityManager from './inactivity_manager';
import NotificationManager from './notifications_manager';
import AddressEditor from './address_editor';
import BuyerSearch from './buyer_search';
import IdentityCard from './identity_cards';
import './post_statistics';

window.IdentityCard = IdentityCard;
window.buyerSearch = null;
window.boxmethods = null;
window.isIE11 = null;

initializeCountriesLang(currentLanguage);

$(document).ready(function() {
	window.inactivityManager = new InactivityManager();
	inactivityManager.calcActivity();

	isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

	if(!isIE11)
	{
		try
		{
			//Hide close app button in browser
			var btnExit = $(".exitApplication");
			btnExit.hide();
			
			if (typeof window.BoxOfficeMethods != "undefined")
			{
				boxmethods = BoxOfficeMethods;
				getBatteryInfo();
				setInterval(getBatteryInfo, 30000);
				
				btnExit.show();
				
			}
		}
		catch (e)
		{
		}
	}
	
	let p4Timezone = localStorage.getItem('timezone');
	if (p4Timezone == null)
	{
		p4Timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	}
	
	if (userTimeZone == null || userTimeZone == "" || userTimeZone != p4Timezone)
	{
		BackofficeAjax.changeUserTimeZone(p4Timezone, updateUserTimeZone);
	}
	
	buyerSearch = new BuyerSearch("buyerSearch");

	if(typeof userIsLogged != "undefined" && userIsLogged)
	{
		if((typeof authenticationList == 'undefined') && userId != null && boxmethods == null)
		{
			window.notificationManager = new NotificationManager();
			notificationManager.loadNewNotifications();
			document.getElementById('load-notifications-btn').addEventListener("click", () => notificationManager.loadOldNotifications());
		}
	}
});

$('#formBusquedaComprador').on("submit", function(ev) {
	ev.preventDefault();
});

$('#formBusquedaComprador').on('keypress', function(e){
   if(e.keyCode == 13)
   {
     document.getElementById("find_user_button").click();
   }
});

$('#vBusquedaComprador').on('keypress', function(e){
   if(e.keyCode == 13)
   {
     document.getElementById("find_user_button").click();
   }
});

function getCursorPosition(element, event) {
  const rect = element.getBoundingClientRect();
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;
  const x = event.clientX - centerX;
  const y = centerY - event.clientY;
  return { x, y };
}

window.animateAIButtons = function() {
	const buttonsIA = document.querySelectorAll('button.btn-ia');
	
	if(buttonsIA != null && buttonsIA.length > 0)
	{
		[...buttonsIA].forEach((button) => {
			button.addEventListener("pointermove", (event) => {
				const { x, y } = getCursorPosition(event.target, event);
				button.style.setProperty("--coord-x", x);
				button.style.setProperty("--coord-y", y);
			});
			button.addEventListener("pointerleave", (event) => {
				button.style.setProperty("--coord-x", 0);
				button.style.setProperty("--coord-y", 0);
			});
		});
	}
}

function updateUserTimeZone(storedTimezone)
{
	userTimeZone = storedTimezone;
	localStorage.setItem('timezone', storedTimezone);
}

animateAIButtons();